// Angular
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ipDisplayer',
  standalone: true
})
export class IpDisplayerPipe implements PipeTransform {

  constructor() { }

  transform(value: string, args?: any): any {

    if (value?.includes("::ffff:"))
      return value?.replace("::ffff:", "");
    else
      return value;

  }

}
